import "@shoelace-style/shoelace/dist/components/tab/tab.js";
import "@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js";
import "@shoelace-style/shoelace/dist/components/tab-group/tab-group.js";

import { css, html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";

import "./MapCacheDownloadedControl";
import "./MapCachePlacesControl";
import "./MapCachePlaceMediaControl";
import SlTabGroup from "@shoelace-style/shoelace/dist/components/tab-group/tab-group.js";

@customElement("ds-map-cache-control")
export class MapCacheControl extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .container {
                min-height: 50vh;
            }

            sl-tab-group {
                width: 100%;
            }

            sl-tab-panel {
                width: 100%;
            }

            #tab-group {
                height: 100%;
            }
        `,
    ];

    @query("#tab-group") _tabGroup?: SlTabGroup;

    override render() {
        return html`<div class="container">
            <p>
                Download maps and place photos and videos for offline use when you do not have a
                mobile connection
            </p>
            <sl-tab-group
                id="tab-group"
                @ds-download-started=${() => {
                    this._tabGroup?.show("downloads");
                }}
            >
                <sl-tab slot="nav" panel="viewport">Viewport</sl-tab>
                <sl-tab slot="nav" panel="place-media">Place media</sl-tab>
                <sl-tab slot="nav" panel="downloads">Downloads</sl-tab>

                <sl-tab-panel name="viewport"
                    ><ds-map-cache-places-control cacheType="viewport"></ds-map-cache-places-control
                ></sl-tab-panel>
                <sl-tab-panel name="place-media"
                    ><ds-map-cache-place-media-control></ds-map-cache-place-media-control
                ></sl-tab-panel>
                <sl-tab-panel name="downloads"
                    ><ds-map-cache-downloaded-control></ds-map-cache-downloaded-control
                ></sl-tab-panel>
            </sl-tab-group>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-map-cache-control": MapCacheControl;
    }
}
